module.exports = __webpack_public_path__ + "static/media/img_nodata.9438f6bd.svg";